import cf from './lxm/cf'
import contact from './lxm/contact'
import form from './lxm/form'
import dashboard from './lxm/dashboard'
import login from './lxm/login'
import search from './lxm/search'
import activity from './lxm/activity'
import qiniu from './lxm/qiniu'
import { httpGet, httpPatch } from './utils'

export default {
  cf,
  contact,
  form,
  dashboard,
  login,
  search,
  activity,
  qiniu,
  getTeamInfo (cb) {
    httpGet(`/api/team/team_info`, cb)
  },
  getNotificationStatus (cb, { type, id }) {
    httpGet(`/api/wechat_notification/status?module_type=${type}&module_id=${id}`, cb)
  },
  toggleNotificationStatus (cb, { type, id }) {
    httpPatch(`/api/wechat_notification/toggle?module_type=${type}&module_id=${id}`, {}, cb)
  },
  fetchWechatJsConfig (cb, { url }) {
    httpGet(`/api/wechat/js-config?url=${url}`, cb)
  }
}




// WEBPACK FOOTER //
// ./src/api/index.js